import React from 'react'

import { getAvgForce, getMaxForce, getMinForce, getWorkoutStats } from 'lib/stats'
import { addCommas } from 'lib/utilities'
import { useWorkoutSession } from 'store/workout/selectors'
import { getWorkoutDisplayForceHits } from 'lib/hit-combinations'

const StatsWorkoutComplete = () => {
  const workoutSession = useWorkoutSession()
  const { avgSpeed, maxSpeed, minSpeed } = getWorkoutStats(workoutSession)
  const displayForceHits = getWorkoutDisplayForceHits(workoutSession)
  const avgForce = Math.round(getAvgForce(displayForceHits))
  const maxForce = Math.round(getMaxForce(displayForceHits))
  const minForce = Math.round(getMinForce(displayForceHits))

  return (
    <div className="row statsWorkoutComplete">
      <div className="col-6 statsWorkoutComplete__box">
        <h3 className="gray light avg">Avg. Force</h3>
        <h3 className="value statsAvg">{addCommas(avgForce)}</h3>
        <h5 className="gray light low">Low</h5>
        <h5 className="value statsLow">{addCommas(minForce)}</h5>
        <h5 className="gray light high">High</h5>
        <h5 className="value statsHigh">{addCommas(maxForce)}</h5>
      </div>
      <div className="col-6 statsWorkoutComplete__box">
        <h3 className="gray light avg">Avg. Speed</h3>
        <h3 className="value statsAvg">{avgSpeed}</h3>
        <h5 className="gray light low">Low</h5>
        <h5 className="value statsLow">{minSpeed}</h5>
        <h5 className="gray light high">High</h5>
        <h5 className="value statsHigh">{maxSpeed}</h5>
      </div>
    </div>
  )
}

export default StatsWorkoutComplete
